import { Alert } from '@mui/material';
import { usePhrase } from '@/hooks';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';

export const NoAccountExists = () => {
    const { t } = usePhrase();

    return (
        <Alert severity="warning">
            {t(WALLET_PHRASES.ONCE_YOU_HAVE_RECEIVED_FIRST_COMPENSATION)}
        </Alert>
    );
};
